module.exports = __webpack_public_path__ + "img/cf.714e4941.svg";